(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["personalizacao"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('personalization-fields')) {
    class PersonalizationFields extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-pf-panel]');
        this.error = this.querySelector('[data-pf-error]');
        this.scope = this.closest('.shopify-section') || document;
        this.maxBytes = 10 * 1024 * 1024;
        this.active = this.dataset.initial === 'true';

        const positionEls = Array.from(this.querySelectorAll('[data-pf-position]'));
        this.positionMode = positionEls.length > 0;
        this.groups = this.positionMode
          ? positionEls.map((el) => this.makeGroup(el, false))
          : [this.makeGroup(this.panel, true)];
        this.names = this.positionMode
          ? this.groups.filter((group) => !group.el.hidden).map((group) => group.name)
          : [];

        this.onPickerChange = (event) => {
          const target = event.target;
          if (target && target.closest && target.closest('variant-picker, swatches-variant-picker-component')) {
            requestAnimationFrame(() => this.sync());
          }
        };
        this.onFieldChange = () => this.validate();

        document.addEventListener('change', this.onPickerChange);
        this.addEventListener('input', this.onFieldChange);
        this.addEventListener('change', this.onFieldChange);
        this.sync();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onPickerChange);
      }

      makeGroup(el, always) {
        return {
          el,
          name: always ? null : el.dataset.position,
          files: Array.from(el.querySelectorAll('[data-pf-file]')),
          texts: Array.from(el.querySelectorAll('[data-pf-text]')),
        };
      }

      selectedValue() {
        const name = this.dataset.optionName;
        const radios = this.scope.querySelectorAll('variant-picker input[type="radio"]');
        for (const radio of radios) {
          if (radio.checked && radio.dataset.optionName === name) return radio.value;
        }
        const selects = this.scope.querySelectorAll('variant-picker select');
        for (const select of selects) {
          if (select.name === 'options[' + name + ']') return select.value;
        }
        return null;
      }

      sync() {
        const value = this.selectedValue();
        if (this.positionMode) {
          if (value !== null) this.names = value.split(' + ');
          this.active = this.groups.some((group) => this.names.includes(group.name));
        } else {
          this.active = value === null ? this.dataset.initial === 'true' : value === this.dataset.trigger;
        }
        this.update();
      }

      update() {
        const active = this.active;
        if (this.panel) this.panel.hidden = !active;

        const productForm = this.scope.querySelector('product-form-component');
        if (productForm) productForm.classList.toggle('pf-personalised', active);

        this.groups.forEach((group) => {
          const on = active && (group.name === null || this.names.includes(group.name));
          if (group.name !== null) group.el.hidden = !on;
          group.files.forEach((file) => {
            file.disabled = !on;
          });
          group.texts.forEach((text) => {
            text.disabled = !on;
          });
        });
        this.validate();
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = false;
      }

      validate() {
        this.groups.forEach((group) => {
          group.files.forEach((file) => file.setCustomValidity(''));
          group.texts.forEach((text) => text.setCustomValidity(''));
          group.texts.forEach((text) => {
            const field = text.closest('.pf-field');
            const counter = field ? field.querySelector('[data-pf-counter]') : null;
            if (counter) {
              const max = Number(text.dataset.max) || text.maxLength;
              counter.textContent = Math.max(0, max - text.value.length) + ' ' + this.dataset.charsLeft;
            }
          });
        });
        if (this.error) {
          this.error.hidden = true;
          this.error.textContent = '';
        }
        if (!this.active) return;

        this.groups.forEach((group) => {
          const on = group.name === null || this.names.includes(group.name);
          if (!on) return;

          let hasContent = false;
          group.files.forEach((fileInput) => {
            const file = fileInput.files && fileInput.files[0];
            if (!file) return;
            hasContent = true;
            if (file.size > this.maxBytes) {
              fileInput.setCustomValidity(this.dataset.sizeMessage);
              this.showError(this.dataset.sizeMessage);
            }
          });
          group.texts.forEach((text) => {
            if (text.value.trim()) hasContent = true;
          });
          if (!hasContent && group.texts[0]) {
            group.texts[0].setCustomValidity(this.dataset.message);
          }
        });
      }
    }
    customElements.define('personalization-fields', PersonalizationFields);

    document.addEventListener('formdata', (event) => {
      const form = event.target;
      if (!form || !form.id || form.id.indexOf('BuyButtons-ProductForm-') !== 0) return;
      const data = event.formData;
      Array.from(data.entries()).forEach(([key, value]) => {
        if (key.indexOf('properties[') === 0 && value instanceof File && value.size === 0) {
          data.delete(key);
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
